import { Protocol } from './index';
import { Category } from '../constants';

const bridges: Protocol[] = [
  {
    name: 'Across Protocol',
    url: 'https://across.to/',
    logoPath: '/logos/across_protocol.jpg',
    category: Category.Bridge,
    twitterUrl: 'https://twitter.com/AcrossProtocol',
  },
  {
    name: 'Celer Network',
    url: 'https://celer.network/',
    logoPath: '/logos/celer_network.jpg',
    category: Category.Bridge,
    twitterUrl: 'https://twitter.com/CelerNetwork',
  },
  {
    name: 'Chainge',
    url: 'https://dapp.chainge.finance/',
    logoPath: '/logos/chainge.jpg',
    category: Category.Bridge,
    twitterUrl: 'https://twitter.com/FinanceChainge',
  },
  {
    name: 'Debridge',
    url: 'https://debridge.finance/',
    logoPath: '/logos/debridge.jpg',
    category: Category.Bridge,
    twitterUrl: 'https://twitter.com/deBridgeFinance',
  },
  {
    name: 'Hop Protocol',
    url: 'https://hop.exchange/',
    logoPath: '/logos/hop_protocol.jpg',
    category: Category.Bridge,
    twitterUrl: 'https://twitter.com/HopProtocol',
  },
  {
    name: 'L2pass',
    url: 'https://l2pass.com/',
    logoPath: '/logos/l2pass.jpg',
    category: Category.Bridge,
    twitterUrl: 'https://twitter.com/L2_Pass',
  },
  {
    name: 'Mes Protocol',
    url: 'https://www.mesprotocol.com/',
    logoPath: '/logos/mes_protocol.jpg',
    category: Category.Bridge,
    twitterUrl: 'https://twitter.com/MESprotocol',
  },
  {
    name: 'Orbiter Finance',
    url: 'https://www.orbiter.finance/',
    logoPath: '/logos/orbiter_finance.jpg',
    category: Category.Bridge,
    twitterUrl: 'https://twitter.com/Orbiter_Finance',
  },
];

export { bridges };
